import React from "react";
import { SettingsIcon } from "@aureskonnect/react-ui";

import {
    ID_GENERAL_SETTINGS,
    ID_CUSTOMER_ACCOUNT,
    ID_LANGUAGE,
    ID_VAT_RATE,
    ID_SALE_SUPPORT,
    ID_SALES_METHOD,
    ID_INFORMATION_MODE,
    ID_PAYMENT_METHOD,
    ID_LOGO,
    ID_CURRENCY,
    ID_FIDELITY,
    ID_POS_INTERCONNECTION,
    ID_AGGREGATOR,
    ID_THIRD_PARTY,
    ID_LOCATION_MANAGEMENT,
    ID_FOOD_COURT,
} from "../../../constants/menu";
import { TFn, MenuItem, ICON_SIZE } from "./types";

export function buildGeneralSettings(
    t: TFn,
    foodCourt: boolean,
    isDefault: boolean
): MenuItem {
    const languageItem: MenuItem = {
        link: "/setting/language",
        menuItem: t("Language"),
        customClassName: "sid_btn_language",
        id: ID_LANGUAGE,
    };

    const subMenu: MenuItem[] = [
        {
            link: "/setting/customer-account",
            menuItem: t("Customer account informations"),
            customClassName: "sid_btn_customerAccountInformation",
            id: ID_CUSTOMER_ACCOUNT,
        },
        ...(!isDefault ? [languageItem] : []),
        {
            link: "/setting/vat-rate",
            menuItem: t("VAT rate"),
            customClassName: "sid_btn_vatRate",
            id: ID_VAT_RATE,
        },
        {
            link: "/setting/saleSupport",
            menuItem: t("Sale Support"),
            customClassName: "sid_btn_salesSupport",
            id: ID_SALE_SUPPORT,
        },
        {
            link: "/setting/sale",
            menuItem: t("Sales method"),
            customClassName: "sid_btn_modeOfSale",
            id: ID_SALES_METHOD,
        },
        {
            link: "/setting/information",
            menuItem: t("Mode of information"),
            customClassName: "sid_btn_informationModes",
            id: ID_INFORMATION_MODE,
        },
        {
            link: "/setting/payment-method",
            menuItem: t("Payment method"),
            customClassName: "sid_btn_paymentChoice",
            id: ID_PAYMENT_METHOD,
        },
        ...(isDefault ? [languageItem] : []),
        {
            link: "/setting/logo",
            menuItem: t("Logo"),
            customClassName: "sid_btn_logo",
            id: ID_LOGO,
        },
        {
            link: "/setting/devise",
            menuItem: t("Currency"),
            customClassName: "sid_btn_currency",
            id: ID_CURRENCY,
        },
        {
            link: "/setting/fidelity",
            menuItem: t("Fidelity"),
            customClassName: "sid_btn_loyalty",
            id: ID_FIDELITY,
        },
        {
            link: "/setting/pos-editor",
            menuItem: t("POS interconnection"),
            customClassName: "sid_btn_posInterconnection",
            id: ID_POS_INTERCONNECTION,
        },
        {
            link: "/setting/aggregator",
            menuItem: t("Aggregator"),
            customClassName: "sid_btn_Aggregator",
            id: ID_AGGREGATOR,
        },
        {
            link: "/setting/thirdParty",
            menuItem: t("Interconnection Third Party"),
            customClassName: "sid_btn_third",
            id: ID_THIRD_PARTY,
        },
        {
            link: "/setting/locationManagement",
            menuItem: t("Location management"),
            customClassName: "sid_btn_locationManagement",
            id: ID_LOCATION_MANAGEMENT,
        },
        ...(foodCourt
            ? [
                  {
                      link: "/setting/foodCourt",
                      menuItem: t("Food court"),
                      customClassName: "sid_btn_foodCourt",
                      id: ID_FOOD_COURT,
                  },
              ]
            : []),
    ];

    return {
        link: "/#",
        menuItem: t("General settings"),
        id: ID_GENERAL_SETTINGS,
        icon: <SettingsIcon {...ICON_SIZE} />,
        subMenu,
        customClassName: "sid_drp_settingGeneral",
    };
}
